import {
  IndexIntegrationComponentAppItesmDiv,
  IndexIntegrationComponentAppSection,
  IndexIntegrationComponentMainDiv,
} from "../../styles/indexcomponentsstyles/indexintegrationstyls";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import { ReactComponent as DiamondIcon } from "./assets/diamond-solid-full.svg";
import { ReactComponent as BrainIcon } from "./assets/brain-solid-full.svg";
import ButtonComponentVariant from "../reusable/header/assetes/buttoncomponents/buttoncomponentvarint";
import logo from "./assets/1.png"
const IndexIntegrationComponent = () => {
  return (
    <IndexIntegrationComponentMainDiv>
      <div>
        <div className="intergration-background-image">

          <img src={logo} alt=""></img>
          

          </div>
        <div className="integration-header">
          <div className="integration-header-container">
            <div>
              <div>
                <HeaderSpan text=" POWERFUL INTEGRATIONS" />
              </div>
            </div>
            <div>
              <div className="integration-header-text-container">
                <h2>Seamlessly Integrate Every App</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="integration-container">
          
          <IndexIntegrationComponentAppSection length={Companys.length } itemwidth={72} gap={60} >
            <div>
              <section className="integration-app-section-container">
                <div className="integration-app-section-holder">
                  <div className="trusted-section-marque-container">
                    <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-right" />
                    <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-left" />

                    <div className="trusted-section-marque-scroll-holder">
                      <section>
                        <ul className="trusted-section-marque-scroll-list">
                          {Companys.map((item, index) => (
                            <IndexIntegrationComponentAppItesmDiv>
                              <div
                                key={index + "marquee items"}
                              >
                                <div className="app-items-container">
                                  <div className="app-item-icon">
                                    {
                                      item.icon
                                    }
                                  </div>
                                </div>
                              </div>
                            </IndexIntegrationComponentAppItesmDiv>
                          ))}
                            {Companys.map((item, index) => (
                            <IndexIntegrationComponentAppItesmDiv>
                              <div
                                key={index + "marquee items"}
                              >
                                <div className="app-items-container">
                                  <div className="app-item-icon">
                                    {
                                      item.icon
                                    }
                                  </div>
                                </div>
                              </div>
                            </IndexIntegrationComponentAppItesmDiv>
                          ))}  {Companys.map((item, index) => (
                            <IndexIntegrationComponentAppItesmDiv>
                              <div
                                key={index + "marquee items"}
                              >
                                <div className="app-items-container">
                                  <div className="app-item-icon">
                                    {
                                      item.icon
                                    }
                                  </div>
                                </div>
                              </div>
                            </IndexIntegrationComponentAppItesmDiv>
                          ))}
                          
                        </ul>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </IndexIntegrationComponentAppSection>
           <IndexIntegrationComponentAppSection length={Companys.length } itemwidth={72} gap={60} reverse={true} >
            <div>
              <section className="integration-app-section-container">
                <div className="integration-app-section-holder">
                  <div className="trusted-section-marque-container">
                    <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-right" />
                    <div className="trusted-section-marque-gradient-cover trusted-section-marque-gradient-cover-left" />

                    <div className="trusted-section-marque-scroll-holder">
                      <section>
                        <ul className="trusted-section-marque-scroll-list">
                          {Companys.map((item, index) => (
                            <IndexIntegrationComponentAppItesmDiv>
                              <div
                                key={index + "marquee items"}
                              >
                                <div className="app-items-container">
                                  <div className="app-item-icon">
                                    {
                                      item.icon
                                    }
                                  </div>
                                </div>
                              </div>
                            </IndexIntegrationComponentAppItesmDiv>
                          ))}
                            {Companys.map((item, index) => (
                            <IndexIntegrationComponentAppItesmDiv>
                              <div
                                key={index + "marquee items"}
                              >
                                <div className="app-items-container">
                                  <div className="app-item-icon">
                                    {
                                      item.icon
                                    }
                                  </div>
                                </div>
                              </div>
                            </IndexIntegrationComponentAppItesmDiv>
                          ))}  {Companys.map((item, index) => (
                            <IndexIntegrationComponentAppItesmDiv>
                              <div
                                key={index + "marquee items"}
                              >
                                <div className="app-items-container">
                                  <div className="app-item-icon">
                                    {
                                      item.icon
                                    }
                                  </div>
                                </div>
                              </div>
                            </IndexIntegrationComponentAppItesmDiv>
                          ))}
                          
                        </ul>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </IndexIntegrationComponentAppSection>
          <div></div>
        </div>
        <div>
          <div className="intergration-button-container">
            <ButtonComponentVariant title="Explore all " link="/integration" />
          </div>
        </div>
      </div>
    </IndexIntegrationComponentMainDiv>
  );
};
export default IndexIntegrationComponent;

const Companys = [{
  icon:<BrainIcon/>
},
{
  icon:<DiamondIcon/>
},{
  icon:<BrainIcon/>
},{
  icon:<DiamondIcon/>
},
{
  icon:<DiamondIcon/>
},];
